// Free shipping bar updater for Fox Tan
(function() {
  // Wait for the document to be fully loaded
  document.addEventListener('DOMContentLoaded', function() {
    // Set up a MutationObserver to watch for cart changes
    setupCartObserver();
    
    // Also try to hook into the Ajax cart
    hookIntoAjaxCart();
  });
  
  // Function to set up an observer to watch for cart content changes
  function setupCartObserver() {
    // Check if MutationObserver is supported
    if (!window.MutationObserver) return;
    
    // Get the cart container
    var cartContainer = document.getElementById('CartContainer');
    if (!cartContainer) return;
    
    // Create an observer instance
    var observer = new MutationObserver(function(mutations) {
      // When the cart changes, fetch the current cart data
      fetchCartAndUpdate();
    });
    
    // Configuration of the observer
    var config = { 
      childList: true,
      subtree: true,
      characterData: true
    };
    
    // Start observing
    observer.observe(cartContainer, config);
  }
  
  // Function to hook into the existing Ajax cart
  function hookIntoAjaxCart() {
    // Wait a bit to ensure the Ajax cart is fully loaded
    setTimeout(function() {
      // Check if ajaxCart exists
      if (typeof window.ajaxCart !== 'undefined') {
        // Store the original updateCartCallback
        var originalUpdateCartCallback = window.ajaxCart.updateCartCallback;
        
        // Replace with our own version
        window.ajaxCart.updateCartCallback = function(cart) {
          // Call the original callback
          if (originalUpdateCartCallback) {
            originalUpdateCartCallback(cart);
          }
          
          // Update our shipping bar
          updateShippingBar(cart);
        };
        
        console.log('Successfully hooked into ajaxCart');
      } else {
        console.log('ajaxCart not found, using fallback method');
        
        // Set up event listeners for cart buttons
        setupCartButtonListeners();
      }
    }, 1000);
  }
  
  // Function to set up listeners on cart buttons
  function setupCartButtonListeners() {
    // Get all quantity adjustment buttons
    document.addEventListener('click', function(event) {
      // Check if the clicked element is a quantity adjustment button
      if (event.target.matches('.ajaxcart__qty--plus, .ajaxcart__qty--minus') || 
          event.target.closest('.ajaxcart__qty--plus, .ajaxcart__qty--minus')) {
        // Wait a bit for the cart to update
        setTimeout(fetchCartAndUpdate, 500);
      }
    });
    
    // Listen for changes on quantity inputs
    document.addEventListener('change', function(event) {
      if (event.target.matches('.ajaxcart__qty-num')) {
        // Wait a bit for the cart to update
        setTimeout(fetchCartAndUpdate, 500);
      }
    });
  }
  
  // Function to fetch the current cart data and update the shipping bar
  function fetchCartAndUpdate() {
    fetch('/cart.js')
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        updateShippingBar(cart);
      })
      .catch(function(error) {
        console.error('Error fetching cart:', error);
      });
  }
  
  // Function to update the shipping bar with cart data
function updateShippingBar(cart) {
  // Get the shipping bar elements
  var messageElement = document.querySelector('.free-shipping-message p');
  var progressBar = document.querySelector('.shipping-progress-bar');
  var messageContainer = document.querySelector('.free-shipping-message');
  
  if (!messageElement || !progressBar || !messageContainer) return;
  
  // Get the threshold from the data attribute
  var threshold = parseInt(messageContainer.getAttribute('data-threshold') || 8900);
  
  // Calculate values
  var total = cart.total_price;
  var remaining = threshold - total;
  var progressPercentage = Math.min((total / threshold) * 100, 100);
  
  // Update the message with HTML content
  if (total === 0) {
    messageElement.innerHTML = "<strong style=\"color: #e10098;\">FREE</strong> STANDARD SHIPPING ON <strong style=\"color: #e10098;\">USA</strong> ORDERS OVER $89 USD";
    progressPercentage = 0;
  } else if (total >= threshold) {
    messageElement.innerHTML = "YOU'VE SCORED <strong style=\"color: #e10098;\">FREE</strong> SHIPPING BABE!";
    progressPercentage = 100;
  } else {
    // Format the remaining amount
    var formattedRemaining = '$' + (remaining / 100).toFixed(2);
    messageElement.innerHTML = 'SPEND AN EXTRA <strong style=\"color: #e10098;\">' + formattedRemaining + '</strong> FOR FREE SHIPPING!';
  }
  
  // Update the progress bar
  progressBar.style.width = progressPercentage + '%';
  
  // Update data attribute
  messageContainer.setAttribute('data-current', total);
  
  console.log('Shipping bar updated: ' + progressPercentage + '%');
}
  
  // Initial update
  fetchCartAndUpdate();
})();